import { CHANNEL } from '@boss/constants/corporate-jobs';
import type { QuoteFields } from '@boss/types/corporate-jobs';

export const getQuoteCarouselProps = (entry: QuoteFields) => ({
  quote: entry.quote,
  company: entry.company,
  author: entry.author,
  image: entry.image,
  roundedCorners: CHANNEL === 'jobs-b2c',
});

export default getQuoteCarouselProps;
